/**
 * @generated SignedSource<<fd91edf95a975be492d76127b87f476d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ForgotPasswordInput = {
  clientMutationId?: string | null | undefined;
  email: string;
};
export type useForgotPasswordForm_Mutation$variables = {
  input: ForgotPasswordInput;
};
export type useForgotPasswordForm_Mutation$data = {
  readonly forgotPassword: {
    readonly message: string | null | undefined;
  } | null | undefined;
};
export type useForgotPasswordForm_Mutation = {
  response: useForgotPasswordForm_Mutation$data;
  variables: useForgotPasswordForm_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ForgotPasswordPayload",
    "kind": "LinkedField",
    "name": "forgotPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useForgotPasswordForm_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useForgotPasswordForm_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3679c6ab334e2edfcda10dd933c361d",
    "id": null,
    "metadata": {},
    "name": "useForgotPasswordForm_Mutation",
    "operationKind": "mutation",
    "text": "mutation useForgotPasswordForm_Mutation(\n  $input: ForgotPasswordInput!\n) {\n  forgotPassword(input: $input) {\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "1afe9c65c98593c24ba2bf046e16e9e6";

export default node;
